"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * CoordinatorFlagsConverter.
 *
 * @author ZSr
 */


var CoordinatorFlagsConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(CoordinatorFlagsConverter, _DataObjectConverter_);

  function CoordinatorFlagsConverter() {
    _classCallCheck(this, CoordinatorFlagsConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(CoordinatorFlagsConverter).apply(this, arguments));
  }

  return CoordinatorFlagsConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.CoordinatorFlagsConverter = CoordinatorFlagsConverter;